import { c as _c } from "react/compiler-runtime";
import { useClientOnly } from '@/hooks/useClientOnly';
import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
export function Portal(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    isClient
  } = useClientOnly();
  let t1;
  if ($[0] !== children || $[1] !== isClient) {
    t1 = isClient ? ReactDOM.createPortal(children, document.body) : null;
    $[0] = children;
    $[1] = isClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}